var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageColumn',{attrs:{"paddingMainContents":false}},[_c('div',{staticClass:"pl-3 pt-3 text-xl text-primary-500"},[_vm._v("เพิ่มรถขนส่ง")]),_c('CommonFormWithVehicleEditor',{attrs:{"edit":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }